import React, { Component } from "react";
import swal from "sweetalert";
import service from "../services";
import commonImage from "../commonImage";
import Loader from "./loader";
import DropDown from "./Dropdown";

/*
 * WebsiteLogos Component
 *
 * Website logo / favicon / email logo / reference image uploads and the Evergreen Mode toggle.
 * Moved from the Festival Dates page (headerFooterDate.js) into Festival Website (Home.js).
 */
const isProdEnv = () =>
  ["PROD1", "PROD2", "PROD3"].some((env) => process.env.REACT_APP_ENVIRONMENT.includes(env.toLocaleLowerCase()));

const getDefaultHost = () =>
  isProdEnv()
    ? JSON.parse(process.env.REACT_APP_INSTANCE).filter((env) => env.toLocaleLowerCase() === process.env.REACT_APP_ENVIRONMENT)[0]
    : JSON.parse(process.env.REACT_APP_INSTANCE)[0];

class WebsiteLogos extends Component {
  constructor(props) {
    super(props);
    this.apiserve = new service();
    this.state = {
      host: getDefaultHost(),
      loaderFlag: true,
      evergreenToggle: false,
      evergreenConfig: null,
      isWebConfigEdited: false,
      logo: "",
      icon: "",
      emailLogo: "",
      referenceImage: "",
    };
  }

  componentDidMount = () => {
    this.sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "admin|getDateConfiguration":
          if (!response.error && Array.isArray(response.data)) {
            const evergreen = response.data.filter((_) => _.module === "EVERGREEN_WEBSITE")[0];
            this.setState({
              loaderFlag: false,
              evergreenConfig: evergreen || null,
              evergreenToggle: evergreen ? evergreen.isEnabled : false,
              isWebConfigEdited: false,
            });
          } else {
            this.setState({ loaderFlag: false });
          }
          break;
        case "admin|dateConfiguration":
          if (response.error === true) {
            this.setState({ loaderFlag: false });
            this.apiserve.error((response.data && response.data.error) || "Failed to update");
          } else {
            this.setState({ loaderFlag: false }, () => this.apiserve.success("Updated successful."));
            this.getConfig();
          }
          break;
        default:
          break;
      }
    });
    this.setImageUrls();
    this.getConfig();
  };

  componentWillUnmount = () => {
    if (this.sub) this.sub.unsubscribe();
  };

  getConfig = () => {
    this.apiserve.sendevent("admin|getDateConfiguration", { host: this.state.host });
  };

  assetUrl = (fileName, host = this.state.host) =>
    this.apiserve.imageUrl + "assest/" + (isProdEnv() ? host.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT) + "/" + fileName + "?" + new Date().getTime();

  setImageUrls = (host = this.state.host) => {
    this.setState({
      logo: this.assetUrl("sundance_logo.svg", host),
      icon: this.assetUrl("sundance_favicon.png", host),
      emailLogo: this.assetUrl("sundance_logo.png", host),
      referenceImage: this.assetUrl("Reference-Image.png", host),
    });
  };

  handleChangeInstance = (e) => {
    const host = e.target.value;
    this.setState({ host, loaderFlag: true }, () => {
      this.setImageUrls(host);
      this.getConfig();
    });
  };

  // Shared flow for all four image uploads
  confirmAndUpload = (e, { accept, errorText, confirmText, fileName, logo, emailLogo, isReferenceImage, maxSize }) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!accept(file)) {
      this.apiserve.error(errorText);
      return;
    }
    if (maxSize && file.size > maxSize) {
      this.apiserve.error("Reference image must be less than 1MB");
      e.target.value = "";
      return;
    }
    this.setState({ isWebConfigEdited: true });
    swal({
      title: "Are you sure?",
      text: confirmText,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willReplace) => {
      if (willReplace) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
          setTimeout(() => {
            this.imageUploadScreen(file, false, fileName, logo, event.target.result, emailLogo, isReferenceImage);
          }, 0);
        };
        e.target.value = "";
      }
    });
  };

  isSvg = (file) => file.type === "image/svg+xml" || file.name.includes(".svg");
  isPng = (file) => file.type === "image/png" || file.name.includes(".png");

  uploadLogo = (e) =>
    this.confirmAndUpload(e, { accept: this.isSvg, errorText: "please upload .SVG file only", confirmText: "you want to replace the Festival Logo?", fileName: "sundance_logo.svg", logo: true });

  uploadIcon = (e) =>
    this.confirmAndUpload(e, { accept: this.isPng, errorText: "please upload .PNG file only", confirmText: "you want to replace the Favicon Icon?", fileName: "sundance_favicon.png", logo: false });

  uploadEmailLogo = (e) =>
    this.confirmAndUpload(e, { accept: this.isPng, errorText: "please upload .PNG file only", confirmText: "you want to replace the Email Logo?", fileName: "sundance_logo.png", logo: true, emailLogo: true });

  uploadReferenceImage = (e) =>
    this.confirmAndUpload(e, { accept: this.isPng, errorText: "please upload .PNG file only", confirmText: "you want to replace the Reference Image?", fileName: "Reference-Image.png", logo: false, isReferenceImage: true, maxSize: 1 * 1024 * 1024 });

  imageUploadScreen = (file, IsFPGUpload = false, fileName, logo, img, emailLogo = false, isReferenceImage = false) => {
    const uploadLocation = this.apiserve.formbucket;
    uploadLocation.street = "assest/" + (isProdEnv() ? this.state.host.toLocaleLowerCase() : process.env.REACT_APP_ENVIRONMENT);
    commonImage(file, IsFPGUpload, uploadLocation, img, fileName, "public-read").then(() => {
      swal(`${isReferenceImage ? "Reference Image" : logo ? "Festival Logo" : "Favicon Icon"} Updated Successfully!`, { icon: "success" });
      if (isReferenceImage) {
        this.setState({ referenceImage: this.assetUrl("Reference-Image.png") });
      } else if (logo) {
        if (emailLogo) this.setState({ emailLogo: this.assetUrl("sundance_logo.png") });
        else this.setState({ logo: this.assetUrl("sundance_logo.svg") });
      } else {
        this.setState({ icon: this.assetUrl("sundance_favicon.png") });
      }
    });
  };

  submitWebConfig = (e) => {
    e.preventDefault();
    const date = this.state.evergreenConfig;
    if (!date) {
      this.apiserve.error("Evergreen configuration not found for this host");
      return;
    }
    const data = {
      isEnabled: this.state.evergreenToggle,
      host: this.state.host,
      module: "EVERGREEN_WEBSITE",
      startDate: date.startDate,
      endDate: date.endDate,
      headerStartDate: date.headerStartDate,
      headerEndDate: date.headerEndDate,
      footerStartDate: date.footerStartDate,
      footerEndDate: date.footerEndDate,
    };
    this.setState({ loaderFlag: true, isWebConfigEdited: false });
    this.apiserve.sendevent("admin|dateConfiguration", data);
  };

  render() {
    const instance = JSON.parse(process.env.REACT_APP_INSTANCE);
    return (
      <div className="ticketing_wrapper fpg_tabcontent">
        {this.state.loaderFlag && <Loader />}
        <div className="instane_dropdown">
          <DropDown name="host" options={instance} onChange={this.handleChangeInstance} value={this.state.host} label="" />
        </div>
        <div className="sd_webisite_configuration">
          <div className="field_row horizontal_field">
            <div className="field_row_inner">
              <label className="null">Website Logo (SVG - 25:44)</label>
              <div className="field_input relative">
                <img src={this.state.logo} alt="logo" />
                <label className="pointer" htmlFor="website_logo"><input type="file" accept=".svg" onChange={this.uploadLogo} className="upload_pdf" id="website_logo" />Change Logo</label>
              </div>
            </div>
          </div>
          <div className="field_row horizontal_field">
            <div className="field_row_inner">
              <label className="null">Favicon icon (PNG - 1:1)</label>
              <div className="field_input relative">
                <img src={this.state.icon} alt="icon" />
                <label className="pointer" htmlFor="website_favicon"><input type="file" accept=".png" onChange={this.uploadIcon} className="upload_pdf" id="website_favicon" />Change Icon</label>
              </div>
            </div>
          </div>
          <div className="field_row horizontal_field">
            <div className="field_row_inner">
              <label className="null">Email Logo (PNG - 25:44)</label>
              <div className="field_input relative">
                <img src={this.state.emailLogo} alt="icon" />
                <label className="pointer" htmlFor="email_logo"><input type="file" accept=".png" onChange={this.uploadEmailLogo} className="upload_pdf" id="email_logo" />Change Icon</label>
              </div>
            </div>
          </div>
          <div className="field_row horizontal_field">
            <div className="field_row_inner">
              <label className="null">Reference Image (PNG - max 1MB)</label>
              <div className="field_input relative">
                <img src={this.state.referenceImage} alt="reference" />
                <label className="pointer" htmlFor="reference_image"><input type="file" accept=".png" onChange={this.uploadReferenceImage} className="upload_pdf" id="reference_image" />Change Image</label>
              </div>
            </div>
          </div>
          <div className="field_row horizontal_field">
            <div className="field_row_inner">
              <label className="null">Evergreen Mode</label>
              <label className="switch">
                <input type="checkbox" checked={this.state.evergreenToggle} onChange={() => this.setState({ evergreenToggle: !this.state.evergreenToggle, isWebConfigEdited: true })} />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div className="btn_wrapper"><button className="orangeBTN" disabled={!this.state.isWebConfigEdited} type="button" onClick={this.submitWebConfig}>Save</button></div>
        </div>
      </div>
    );
  }
}

export default WebsiteLogos;
